import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import Layout from "../../../components/layout/Layout";
import "../../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../../assets/InnerCSS/css/styles.css";
import "../../../assets/InnerCSS/css/custom.css";
import InterviewsComponent from "../../../components/admin/interviews/interviews/InterviewsComponent";
import IdNameModel from "../../../models/common/IdNameModel";
import masterDataService from "../../../services/master-data-service";
import toasterUtils from "../../../utils/toaster-utils";
import adminInterviewsService from "../../../services/admin/admin-interviews-service";
import modalUtils from "../../../utils/modal-utils";
import { useHistory } from "react-router";
import { GuidEnum } from "../../../models/enums/GuidEnum";

const Interviews = () => {
    const history = useHistory();
    const [primarySkillList, setPrimarySkillList] = useState<IdNameModel[]>([]);
    const [timeSlots, setTimeSlots] = useState<IdNameModel[]>([]);
    const [interviewerList, setInterviewerList] = useState<IdNameModel[]>([]);
    const [cityList, setCityList] = useState<IdNameModel[]>([]);
    const [refreshSkills, setRefreshSkills] = useState<number>(2);
    const [refreshTimeSlots, setRefreshTimeSlots] = useState<number>(2);
    const [refreshInterviewer, setRefreshInterviewer] = useState<number>(2);
    const [refreshCity, setRefreshCity] = useState<number>(2);
    const [status, setStatus] = useState<IdNameModel[]>([]);
    const [refreshStatus, setRefreshStatus] = useState<number>(2);

    useEffect(() => {
        getTimeSlots();
        fillPrimarySkills();
        fillInterviewers();
        fillCity();
        getStatus();
    }, []);

    const fillPrimarySkills = () => {
        setRefreshSkills(2);
        modalUtils.showLoader();
        masterDataService.loadPrimarySkills().then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setPrimarySkillList(res.items);
            setRefreshSkills(refreshSkills * 5);
        }).catch((error) => {
            setRefreshSkills(refreshSkills * 5);
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const getTimeSlots = () => {
        setRefreshTimeSlots(2);
        modalUtils.showLoader();
        masterDataService.loadTimeSlots().then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setTimeSlots(res.items);
            setRefreshTimeSlots(refreshTimeSlots * 5);
        }).catch((error) => {
            setRefreshTimeSlots(refreshTimeSlots * 5);
            modalUtils.closeModal();
            toasterUtils.showError("Erorr fetching Time Slots");
        });
    };

    const fillInterviewers = () => {
        setRefreshInterviewer(2);
        modalUtils.showLoader();
        adminInterviewsService.getInterviewersByPrimarySkill(0, GuidEnum.Empty).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setInterviewerList(res.items);
            setRefreshInterviewer(refreshInterviewer * 5);
        }).catch((error) => {
            setRefreshInterviewer(refreshInterviewer * 5);
            modalUtils.closeModal();
            toasterUtils.showError("Erorr fetching Interviewers");
        });
    };

    const fillCity = () => {
        setRefreshCity(2);
        modalUtils.showLoader();
        masterDataService.loadAllCities().then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setCityList(res.items);
            setRefreshCity(refreshCity * 5);
        }).catch((error) => {
            setRefreshCity(refreshCity * 5);
            modalUtils.closeModal();
            toasterUtils.showError("Erorr fetching Cities");
        });
    };

    const getStatus = () => {
        setRefreshStatus(2);
        modalUtils.showLoader();
        masterDataService.loadStatus().then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setStatus(res.items);
            setRefreshStatus(refreshStatus * 5);
        }).catch((error) => {
            setRefreshStatus(refreshStatus * 5);
            modalUtils.closeModal();
            toasterUtils.showError("Erorr fetching Status");
        });
    };

    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> Interviews
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header"> Interviews </h4>
            </div>
            {refreshSkills > 2 && refreshTimeSlots > 2 && refreshInterviewer > 2 && refreshCity > 2 &&
                <InterviewsComponent
                    primarySkillsList={primarySkillList}
                    timeSlotsList={timeSlots}
                    interviewerList={interviewerList}
                    cityList={cityList}
                    statusList={status} />
            }
        </Layout>
    );
};
export default Interviews;